import { TripRole } from '../../../passporter-services/itinerary/apiTypes'

export type ApiInvitation = {
	code: string
	id: string
	itinerary_id: string
	referral_id: string
	role: TripRole
	url: string
	email?: string
	status?: API_TRIP_INVITATION_STATUS
}

export enum API_TRIP_INVITATION_STATUS {
	PENDING = 'pending',
	ACCEPTED = 'accepted',
	CANCELLED = 'cancelled',
}
